import useSWR from 'swr';
import {
  createAdminPromptLibraryApi,
  listAdminFirmPrompts,
} from '@/lib/promptLibraryApi';
import type { PromptResponse } from '@/components/case-partner/types';

const ADMIN_PROMPTS_KEY = '/prompt-library/firm';

export function useAdminFirmPrompts(options: { enabled?: boolean } = {}) {
  const { data, error, isLoading, mutate } = useSWR<PromptResponse[]>(
    options.enabled === false ? null : ADMIN_PROMPTS_KEY,
    listAdminFirmPrompts,
  );

  return {
    prompts: data ?? [],
    isLoading,
    isError: error,
    mutate,
  };
}

export { createAdminPromptLibraryApi, ADMIN_PROMPTS_KEY };
